module.exports = __webpack_public_path__ + "alaska_bg_first_374x260.5e5892c.jpg";